/**
 * @type {'DEV' | 'PROD' | 'LOCAL'}
 */
const ENV = "PROD";

const API_URL =
  ENV === "PROD"
    ? "https://gi-mobile.azurewebsites.net/api/"
    : ENV === "DEV"
    ? "https://gi-mobile-dev.azurewebsites.net/api/"
    : "http://localhost:7071/api/";

const CREDENTIALS = "include";

/**
 * block login to all users except specifically allowed internal developers
 */
export const INTERNAL_ONLY = false;

export const get = async (url, callback, errorCallback) => {
  console.log(`GET: ${API_URL}${url}`);
  fetch(`${API_URL}${url}`, {
    method: "GET",
    credentials: CREDENTIALS
  })
    .then((response) => {
      if (response.ok) {
        response.json().then((j) => callback(j));
      } else {
        if (errorCallback) {
          errorCallback();
        }
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback();
      }
    });
};

export const post = async (url, body, callback, errorCallback) => {
  console.log(`POST: ${API_URL}${url}`);
  console.log("body: ", body);
  return fetch(`${API_URL}${url}`, {
    method: "POST",
    body: JSON.stringify(body),
    credentials: CREDENTIALS
  })
    .then((response) => {
      console.log(`POST: ${API_URL}${url}`);
      if (response.ok) {
        console.log(`${response.status}: ${response.body}`);
        response.json().then((j) => callback(j));
      } else {
        console.log(`${response.status}: ${response.body}`);
        response.json().then((j) => {
          if (errorCallback) errorCallback(j);
        });
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};
